export default "__VITE_ASSET__49c60045__"